// src/utils/DeleteConfirmationModal.jsx
import React from 'react';
import { createPortal } from "react-dom";

const DeleteConfirmationModal = ({
  show,
  onClose,
  onConfirm,
  objectName = "item",
  itemName,
  bodyContent
}) => {
  if (!show) return null;

  return createPortal(
    <div className="modal fade show d-block bg-dark bg-opacity-50" style={{ zIndex: "var(--num-1000000000 )" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <p className="mb-0 ev-fs-15 ev-bold-med">
              Confirm Delete {objectName.charAt(0).toUpperCase() + objectName.slice(1)}
            </p>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body ev-fs-12">
            <p>
              Are you sure you want to delete the {objectName}: <strong>{itemName}</strong>?
            </p>
            {bodyContent && (
              <div>
                {bodyContent}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary ev-btn-reg"
              onClick={onClose}
            >
              Cancel
            </button>
            <button 
              type="button" 
              className="btn btn-danger ev-btn-reg"
              onClick={onConfirm}
            >
              Delete {objectName.charAt(0).toUpperCase() + objectName.slice(1)}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteConfirmationModal;